module.exports = __webpack_public_path__ + "img/hr-sand-rock-medium-05.f8a98e55.png";